import {
    COUNTRY_DOCUMENT_TYPE_NIE,
    COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
    COUNTRY_DOCUMENT_TYPE_PP,
} from '../../constants/multiLanguage';

const React = require('react');
const PropTypes = require('prop-types');
const formActions = require('react-redux-form').actions;
const { bindActionCreators } = require('redux');
import { formatText } from 'core/i18n';
const { COUNTRY_PREFIX_UA } = require('constants/multiLanguage');
const { CREDIT_CARD, ROBO } = require('constants/userProfile');
const { connect } = require('react-redux');
import { Fragment } from 'react';
import './prefixSelector.scss';
import IconClose from 'assets/icons/icon-close.svg';
import { recordEvent } from 'utilities/uTagging';
const { getReferencePrefixByCountry } = require('utilities/multiLanguageHelper');
class PrefixSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            localCode: getReferencePrefixByCountry(),
            showUkraine: false,
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.handleUkrainePrefix();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleDropClose = () => {
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            categoriaEvento: '/onboarding/completa-tus-datos-generales/',
            accionEvento: 'telefono/prefijo',
            etiquetaEvento: 'desplegable/cerrar',
        });
        this.setState({ show: false });
    };

    handleDropOpen = () => {
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            categoriaEvento: '/onboarding/completa-tus-datos-generales/',
            accionEvento: 'telefono/prefijo',
            etiquetaEvento: 'desplegable/abrir',
        });
        this.setState({ show: true });
    };

    handleLinkEvent = () => {
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            categoriaEvento: '/onboarding/completa-tus-datos-generales/',
            accionEvento: 'telefono/prefijo',
            etiquetaEvento: 'desplegable/llamar',
        });
    };

    getPrefix = () => {
        const { userProfile } = this.props;
        const { localCode } = this.state;
        return userProfile.cellphonePrefix ? userProfile.cellphonePrefix : localCode;
    };

    handleSelect = async e => {
        const { handleSave, formActions, userProfile, inputValue, executeValidations } = this.props;
        const { localCode } = this.state;
        const value = e.currentTarget.getAttribute('data-value');
        const option = value === localCode ? 'option1' : 'option2';
        recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
            categoriaEvento: '/onboarding/completa-tus-datos-generales/',
            accionEvento: 'telefono/prefijo',
            etiquetaEvento: `desplegable/seleccionar/${option}`,
        });
        if (userProfile.cellphonePrefix === value) {
            return this.setState({ show: false });
        }
        handleSave('cellphonePrefix', value);
        await formActions.change('userProfile.cellphonePrefix', value);
        inputValue && executeValidations({ target: { value: inputValue } });
        this.setState({ show: false });
    };

    isSelected = value => {
        return value === this.getPrefix() ? 'selected' : '';
    };

    handleClickOutside(event) {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.handleDropClose();
        }
    }

    handleUkrainePrefix() {
        const { cellPhoneUkraine, userProfile } = this.props;

        if (
            userProfile.investmentType === CREDIT_CARD ||
            userProfile.investmentType === ROBO ||
            this.isUkraineOptionDisabled()
        ) {
            return;
        }

        this.setState({ showUkraine: cellPhoneUkraine });
    }

    isUkraineOptionDisabled = () => {
        const {
            userProfile: { documentType },
        } = this.props;

        const documentTypesToActivate = [
            COUNTRY_DOCUMENT_TYPE_PP,
            COUNTRY_DOCUMENT_TYPE_NIE,
            COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
        ];

        return !documentTypesToActivate.includes(documentType);
    };

    render() {
        const { show, localCode, showUkraine } = this.state;
        return (
            <Fragment>
                <span className="input-group-addon visible addon-enable" onClick={this.handleDropOpen}>
                    {this.getPrefix()}
                </span>
                {show && (
                    <Fragment>
                        <div className="background-blocker" />
                        <div ref={this.wrapperRef} className={`dropdown-content`}>
                            <div className="mobile-extra-box">
                                <div className="dropdown-mobile-close-icon">
                                    <img src={IconClose} onClick={this.handleDropClose} />
                                </div>

                                <p>{formatText('phoneScreen-subtitle')}</p>
                                <span className="dropdown-option-separator" />
                            </div>
                            <Fragment>
                                <div
                                    className={`dropdown-option ${this.isSelected(localCode)}`}
                                    data-value={localCode}
                                    onClick={this.handleSelect}
                                >
                                    {formatText('phoneScreen-local')}
                                </div>
                                <div className="dropdown-box-separator">
                                    <span className="dropdown-option-separator" />
                                </div>
                            </Fragment>
                            {showUkraine && (
                                <Fragment>
                                    <div
                                        className={`dropdown-option ${this.isSelected(COUNTRY_PREFIX_UA)}`}
                                        data-value={COUNTRY_PREFIX_UA}
                                        onClick={this.handleSelect}
                                    >
                                        {formatText('phoneScreen-ukraine')}
                                    </div>
                                    <div className="dropdown-box-separator">
                                        <span className="dropdown-option-separator" />
                                    </div>
                                </Fragment>
                            )}
                            <div className="dropdown-info">
                                <span>
                                    <p>{formatText('phoneScreen-subtitle')}</p>
                                </span>
                                <span>
                                    {formatText('phoneScreen-description1')}
                                    <a
                                        onClick={this.handleLinkEvent}
                                        href={`tel:${formatText('phoneScreen-telephone')}`}
                                    >{` ${formatText('phoneScreen-telephone')} `}</a>
                                    {formatText('phoneScreen-description2')}
                                </span>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

PrefixSelector.propTypes = {
    userProfile: PropTypes.object.isRequired,
    handleSave: PropTypes.func,
    formActions: PropTypes.object.isRequired,
};

module.exports.constructor = PrefixSelector;
module.exports.PrefixSelector = PrefixSelector;
module.exports.PrefixSelector = connect(
    state => ({
        userProfile: state.userProfile,
        cellPhoneUkraine: state.featureFlagging.getIn(['data', 'ucranianCellphonePrefix']),
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(PrefixSelector);
